/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteColumnPresetMutationResponse,
  DeleteColumnPresetPathParams,
} from '../types/DeleteColumnPreset'

function getDeleteColumnPresetUrl({
  id,
}: {
  id: DeleteColumnPresetPathParams['id']
}) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/column-presets/${id}/` as const,
  }
  return res
}

/**
 * @summary Delete a column preset
 * {@link /api/v1/column-presets/:id/}
 */
export async function deleteColumnPreset(
  { id }: { id: DeleteColumnPresetPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteColumnPresetMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteColumnPresetUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
